import { defineComponent as _defineComponent } from 'vue'
import { info, invalidInfo, auth } from '@/app/program/store/auth'
import { ref, computed } from 'vue'
import { copyText } from '@/utils/index'
import { message } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const columns = [
  { title: '授权码', dataIndex: 'keyId' },
  {
    title: '剩余天数',
    dataIndex: 'surplus',
    slots: { customRender: 'surplus' }
  },
  { title: '状态', dataIndex: 'use', slots: { customRender: 'use' } }
]

const showInfo = computed(() => {
  if (!info.value && !invalidInfo.value) {
    return
  } else {
    return {
      ...(info.value || invalidInfo.value),
      use: info.value ? true : false
    }
  }
})

const getSurplus = surplus =>
  surplus < 0 ? `过期${-surplus}天` : `剩余${surplus}天`
const visible = ref(false)
const secret = ref('')

const authSecret = async () => {
  await auth({ keyId: info.value.keyId, secret: secret.value })
  message.success('授权成功！')
  visible.value = false
}
const copy = async () => {
  await copyText(info.value.keyId)
  message.success('复制成功')
}

const __returned__ = { columns, showInfo, getSurplus, visible, secret, authSecret, copy }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})